// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"337c8c1d","455":"321450c6"}[chunkId] + ".chunk.js";
};